export function priceFormatter(value = 0, decimals = 2, withoutCurrency = true) {
    return value % 1 === 0 ? value?.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + (withoutCurrency ? ' Ft' : '') : value?.toFixed(decimals).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + (withoutCurrency ? ' Ft' : '');
}